module.exports = __webpack_public_path__ + "static/img/pic2.8b37a65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case1/pic2.jpg
// module id = PI0+
// module chunks = 1